import weforsys from '@/utils/weforsys';
export function getToken() {
  return weforsys.storageGet('token');
}
export function setToken(token) {
  return weforsys.storageSet({
    token: token
  });
}
export function removeToken() {
  return weforsys.storageRemove('token');
}
export function getLock() {
  return weforsys.storageGet('lock');
}
export function setLock(lock) {
  return weforsys.storageSet({
    lock: lock
  });
}
export function removeLock() {
  return weforsys.storageRemove('lock');
}